import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import { numDifferentiation } from '@shared/utils'

export default function AuctionSummery({ overview }) {
  if (
    overview?.nTotalRegisteredPlayer ||
    overview?.nTotalSoldPlayer ||
    overview?.nTotalUnSoldPlayer ||
    overview?.nTotalOverseasPlayer ||
    overview?.nRTMUsed ||
    overview?.nTotalMoneySpent
  ) {
    return (
      <div className={`${styles.summary} light-bg br-lg position-relative mb-3`}>
        <div className={`${styles.prices} ${styles.summaryList} d-flex align-items-start justify-content-around text-center`}>
          {overview?.nTotalRegisteredPlayer > 0 && (
            <div className={`${styles.col} flex-grow-1`}>
              <div className={`${styles.stats} mb-1 br-md font-semi`}>{overview?.nTotalRegisteredPlayer}</div>
              <p className={'font-semi mb-0'}>REG Players</p>
            </div>
          )}
          {overview?.nTotalSoldPlayer > 0 && (
            <div className={`${styles.col} flex-grow-1`}>
              <div className={`${styles.stats} mb-1 br-md font-semi`}>{overview?.nTotalSoldPlayer}</div>
              <p className={'font-semi mb-0'}>Players Sold</p>
            </div>
          )}
          {overview?.nTotalUnSoldPlayer > 0 && (
            <div className={`${styles.col} flex-grow-1`}>
              <div className={`${styles.stats} mb-1 br-md font-semi`}>{overview?.nTotalUnSoldPlayer}</div>
              <p className={'font-semi mb-0'}>Players UnSold</p>
            </div>
          )}
          {overview?.nTotalOverseasPlayer > 0 && (
            <div className={`${styles.col} flex-grow-1`}>
              <div className={`${styles.stats} mb-1 br-md font-semi`}>{overview?.nTotalOverseasPlayer}</div>
              <p className={'font-semi mb-0'}>Overseas Sold</p>
            </div>
          )}
          {overview?.nRTMUsed > 0 && (
            <div className={`${styles.col} flex-grow-1`}>
              <div className={`${styles.stats} mb-1 br-md font-semi`}>{overview?.nRTMUsed}</div>
              <p className={'font-semi mb-0'}>RTMs Used</p>
            </div>
          )}
          {overview?.nTotalMoneySpent > 0 && (
            <div className={`${styles.col} flex-grow-1`}>
              <div className={`${styles.stats} mb-1 br-md font-semi`}>{numDifferentiation(overview?.nTotalMoneySpent)}</div>
              <p className={'font-semi mb-0'}>Amount Spent</p>
            </div>
          )}
        </div>
      </div>
    )
  } else return null
}
AuctionSummery.propTypes = {
  overview: PropTypes.object
}
